import { render, staticRenderFns } from "./imageManagement.vue?vue&type=template&id=658b3fd2&scoped=true&"
import script from "./imageManagement.vue?vue&type=script&lang=js&"
export * from "./imageManagement.vue?vue&type=script&lang=js&"
import style0 from "./imageManagement.vue?vue&type=style&index=0&id=658b3fd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658b3fd2",
  null
  
)

export default component.exports